import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const API_BASE = import.meta.env.VITE_API_BASE ?? 'http://localhost:3200';

/** Admin-side better-auth client pointed at the api. */
export const authClient = createAuthClient({
  baseURL: API_BASE,
  basePath: '/v1/auth',
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
